import type {Rank, RankDto } from '../types';

export function rankFromDto(dto: RankDto): Rank{
  return {
    id: dto.id,
    short: dto.rank_short,
    sort: dto.rank_sort,
    name: dto.rank_name,
  };
}
